export const OK = 200;
export const NOT_FOUND = 404;
export const UNAUTHORIZED = 401;
export const SERVER_ERROR = 500;
